import { useState, useEffect } from 'react';

export const useMainHeight = () => {
  const [mainHeight, setMainHeight] = useState(350);

  useEffect(() => {
    requestAnimationFrame(() => {
      setTimeout(() => {
        const mainElement = document.querySelector('main');
        const height = mainElement.offsetHeight - 75;
        setMainHeight(height);

        function handleNewRoute() {
          setMainHeight(height);
        }

        window.addEventListener('hashchange', handleNewRoute);
        return () => window.removeEventListener('hashchange', handleNewRoute);
      }, 0);
    });
  }, []);

  return mainHeight;
};
